<button
    pButton
    [severity]="severity()"
    [icon]="icon() ? icon() + '' : ''"
    [title]="title() ?? label() ?? ''"
    [label]="label() ?? ''"
    [attr.aria-label]="ariaLabel()"
    [disabled]="!!disabled()"
    [loading]="!!loading()"
    [text]="!!text() || variant() === 'link'"
    [outlined]="!!outlined()"
    [rounded]="variant() === 'icon-only'"
    [attr.data-testid]="testId()"
    (click)="clicked.emit($event)"
    (keydown.enter)="clicked.emit($event)"
    [class.it-button-link]="variant() === 'link'"
    [class.has-hover-bg]="!!hoverBackgroundColor()"
    [style.border]="border()"
    [style.backgroundColor]="backgroundColor()"
    [style.fontSize]="fontSize()"
    [style.color]="color()"
    [style.padding]="padding()"
    [style.flex]="fullWidth() ? 1 : undefined"
    [style.width]="width()"
    [style.borderRadius]="
        variant() === 'square' || variant() === 'link' ? '0' : undefined
    "
    [style.--hover-bg-color]="hoverBackgroundColor()"
    type="button"
></button>
